<template>
  <div class="containerC">
      <div class="topPainelC">     
          <img src="/sandboxfront/IGPM/P.png" alt="" width="245px">       
      </div>
      <div :class="{rolagemCima:true,rolagemCimaA:rolagemCimaA}" @click="IrIndice">
      <span>^</span>
      </div>
      <div style="display: flex;flex-direction: column; align-items: center;margin-top:40px" class="posAnd">
        <h3 style="color: #383838;font-weight: bolder;margin-bottom:0px;"  id="indice">Cálculo dos Ìndices</h3>
        <Categorias @getTexto="texto = $event" @deixarFalse="resultado = false"/>
        <div class="backgrounConteudo"> 
            <div class="containerConteudo">
             
                <div style="display: flex; justify-content: space-between;margin-top: 40px;align-items: center;border-bottom: 1px solid #707070;padding-bottom:20px;">
                   <img  src="/sandboxfront/IGPM/icv.svg" alt="" v-if="$route.params.categoria == '1'">
                   <img  src="/sandboxfront/IGPM/igpdifgv.svg" alt="" v-else-if="$route.params.categoria == '2'">
                       <img  src="/sandboxfront/IGPM/igpmfgv.svg" alt="" v-else-if="$route.params.categoria == '3'">
                       <img  src="/sandboxfront/IGPM/inccmfgv.svg" alt="" v-else-if="$route.params.categoria == '4'">
                       <img  src="/sandboxfront/IGPM/inccfgv.svg" alt="" v-else-if="$route.params.categoria == '5'">
                   <img  src="/sandboxfront/IGPM/ipa.svg" alt="" v-else-if="$route.params.categoria == '7'">
                   <img  src="/sandboxfront/IGPM/ipcfipe.svg" alt="" v-else-if="$route.params.categoria == '8'">
                   <img  src="/sandboxfront/IGPM/ipcaibge.svg" alt="" v-else-if="$route.params.categoria == '9'">
                   <img  src="/sandboxfront/IGPM/ipca.svg" alt="" v-else-if="$route.params.categoria == '10'">
                   <img  src="/sandboxfront/IGPM/ipcdi.svg" alt="" v-else-if="$route.params.categoria == '11'">
                   <img  src="/sandboxfront/IGPM/igpdifgv.svg" alt="" v-else>
                   <div style="margin-left:30px;">
                     <div>
                       <p style="font-size: 18px;font-weight: bold;">{{$store.state.texto}}<p>           
                         
                                     <div v-html="texto" style="text-align: justify;">
                        

                      </div>
                     </div>
                  
                  </div>
                </div>
                <div style="text-align: center;">
                    <h4 style="color:#565656;font-weight:bold;margin:40px 0px;">Cálculo de Projeção</h4>
                      <div>
                        <div class="input-container " style="margin-right: 30px;">
                        <p>Valor</p>
                        <div class="input-style"><i class="icon-map fas fa-dollar-sign"></i></div>
                        <money class="input-calculo" v-model="valor" v-bind="money"></money>
                        </div>
                        <div class="input-container">
                        <p>Data Início</p>
                        <div class="input-style"><i class="icon-map fas fa-calendar-day" ></i></div>
                            <datepicker :disabled-dates="{from: new Date()}" class="input-datainicio" :format="'MM/yyyy'" :language="br" :minimumView="'month'" :maximumView="'month'"></datepicker>
                        </div>
                            <div class="input-container">
                            <p>Data Fim</p>
                            <div for="datafim" class="input-style"><i class="icon-map fas fa-calendar"></i></div>
                            <datepicker :disabled-dates="{from: new Date()}" class="input-datafim" :format="'MM/yyyy'" :language="br" :minimumView="'month'" :maximumView="'month'" ></datepicker>
                        </div>  
                    </div>
                    <button class="btnCa" @click="calcular"  v-show="print">
                        <span v-if="spiner">
                          <b-spinner label="Loading..."></b-spinner>
                        </span>
                        <span v-else>calcular</span>
                      </button>
                      <div style="    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
    border-top: 1px solid rgb(112, 112, 112);
    padding-top: 20px;    flex-direction: column;
" v-show="resultado">
<div  id="printable">
<h4 style="color:#565656;font-weight:bold;margin:40px 0px;text-align:center;"  v-show="print" id="calc">Resultados</h4>
<div  style="    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 900px;
    width: 100%;
    border: 1px solid #AF3437;
    height: 95px;
    border-radius: 5px;
    background: #fff;
    margin-bottom:60px;">
  <div class="bloco" style="display: flex;">
    <div class="incial" style="display: flex;">
      <div class="dataincio">
        <img src="/sandboxfront/igpm/inicial.svg" alt="">
        <div class="a">
          <p>Data Início</p>
          <span>{{ dataI }}</span>
        </div>
      </div>
      <div class="dataincio">
        <span style="font-size: 53px;
    color: rgb(175, 52, 55);">R$</span>
        <div class="a">
          <p>Valor Inicial</p>
           <span>{{valorI}}</span>
        </div>
      </div>
    </div>
    <div class="linha" style="height: 54px; width: 1px; background: #AF3437;">
    </div>
    <div class="incial">
      <div class="dataincio">
        <img src="/sandboxfront/igpm/final.svg" alt="">
        <div class="a">
          <p>Data Fim</p>
          <span>{{dataF }}</span>
        </div>
      </div>
      <div class="dataincio">
        <span style="font-size: 53px;
    color: rgb(175, 52, 55);">R$</span>
        <div class="a">
          <p>Valor Final</p>
            <span>{{valorF }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
      
                        <table v-if="motraTable">
          <tr class="trtable">
            <th class="thtable">
              Data Referência
            </th>
            <th class="thtable">
              Valor Inicial
            </th >
            <th class="thtable">
              Cotação Índice
            </th>
            <th class="thtable">
              Valor Correção
            </th>
            <th class="thtable">
              Valor Final
            </th>
          </tr>
            <tr class="trtable" v-for="(row,i) in dadosTable.itens" :key="i" >           
            <td class="tdtable" >
             {{ row.ref }}
            </td>
            <td class="tdtable" >
             {{row.valor_Inicial }}
            </td>
            <td class="tdtable">
             {{ row.cotacao_indice }}
            </td>
            <td class="tdtable" >
             {{ row.valor_Correcao }}
            </td>
            <td class="tdtable" >
             {{row.valor_final }}
            </td>
          </tr>   
      </table>
   
      <div v-else>
        <p style="    font-weight: 600;    font-size: 22px;">Erro no resultado</p>
      </div>
      </div>
      <div v-show="print" style="display: flex;
    justify-content: flex-end;
    width: 100%;
        margin-bottom: 40px;
    
    max-width: 900px;">
         <button @click="imprimir" style="height: 45px;
    width: 140px;
    border: none;
    border-radius: 5px;
    color: #fff;
    background: #AF3437;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    "><img src="/sandboxfront/IGPM/impressora.svg" alt=""><span>IMPRIMIR</span></button>
      </div>
        
      </div>
            </div>
            </div>
            
        </div>
      </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale'
import cofing from '../services/config'
import {Money} from 'v-money'
export default {
    components: {Money, Datepicker},
    data(){
        return{
          dataI:'',
          dataF:'',
          valorI:'',
          valorF:'',
          print:true,
          rolagemCimaA:true,
          motraTable:false,
          resultado:false,
          dadosTable:[],
          spiner:false,
        dataFim: "",
        dataInicio: "",
        br: ptBR,
        valor: 0,
        texto:'',
        money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
        },           
        }
    },  
    methods:{
      async imprimir(){      
        let r = this.$store.state.opcoes[this.$store.state.id].categoria
        console.log(r)
          var divToPrint=document.getElementById("printable");
          var a = divToPrint.outerHTML
          var  newWin= window.open("https://www.lefisc.com.br/sandboxfront/igpm/impressao","_blank");
           newWin.document.write(`<html> <style>table {
  width: 900px;
  margin-bottom: 60px;
  border-collapse: collapse;
}
tr:nth-child(even) {
	background-color:#FFE6E6  !important;
	}
  tr:nth-child(odd) {
	background-color:#ffffff  !important;
	}
.thtable {
  background: #AF3437;
  color: white;
  margin: 0;
  font-size: 14px;
  text-align: center !important;
  width: 100px;
  height: 50px;
}

.thtable:first-child {
  border-radius: 10px 0 0 0
}

.thtable:last-child {
  border-radius: 0  10px  0 0 
}
.tdtable {
  width: 100px;
  height: 50px;

  font-size: 15px;
  text-align: center;
}

.tdtable:last-child {
  border:none;
}

.trtable {
  border-left: 1px solid rgb(0,0,0,0.35);
  border-right: 1px solid rgb(0,0,0,0.25);
   border-bottom: 1px solid rgb(0,0,0,0.25);
}

.trtable:first-child {
  border:none;
}

.trtable:last-child {
  border-bottom: 1px solid rgb(0,0,0,0.15);
}

.trtable:nth-child(2) {
  border-top: 1px solid rgb(0,0,0,0.15);
} 
.dataincio{
    display: flex;
    align-items: center;
    justify-content: center
}
.dataincio .a{
  text-align: left;
      margin-left: 8px;
}
.dataincio .a span{
  color: #AF3437;
    font-weight: bold;
}
.dataincio .a p{
  color: #565656;
    font-weight: 600;
    
    margin-bottom: 0px;
}
.bloco{
  display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 750px;
    width: 100%;
}
.incial{
  display: flex;
    max-width: 375px;
    justify-content: space-evenly;
    width: 100%;
}
button:focus{
  outline: none;
}
</style>`);

newWin.document.write(`<h2>${r} </h2>`)
newWin.document.write(`<h3>Valor: ${this.valor} </h3>`);
newWin.document.write(`<h3>Data Início: ${this.dataInicio} </h3>`);
newWin.document.write(`<h3>Data Fim: ${this.dataFim} </h3>`);
          newWin.document.write(a);
          newWin.document.write('</html>');
          newWin.print();
          newWin.close();         
        
      },
      IrIndice(){
        window.location.href = '#indice'
      },
      async calcular(){
        this.spiner = true
           this.dataInicio = '01/' + document.querySelector('.input-datainicio')
                          .querySelector('input')
                          .value
                          .toString()
                          .replace(' ', '/')

      this.dataFim = '01/' + document.querySelector('.input-datafim')
                          .querySelector('input')
                          .value
                          .toString()
                          .replace(' ', '/')
        let result = await cofing.getValor(this.dataInicio,this.dataFim,this.valor,this.$store.state.hash ,this.$store.state.id);
        console.log(result)
        if(result.status > 300){
          this.motraTable = false
          this.resultado  = true
          this.spiner = false
        }else{
          this.motraTable = true
          this.resultado  = true
          this.spiner = false
          this.dadosTable =  result.data
          this.dataF =  this.dadosTable.resumo.dataF
          this.dataI =  this.dadosTable.resumo.dataI
          this.valorF =  this.dadosTable.resumo.valorF
          this.valorI =  this.dadosTable.resumo.valorI
        }   
        window.location.href = "#calc"    
      }
    },
    async created(){
      document.documentElement.scrollTop = 0;
      this.texto = await cofing.textos(this.$route.params.categoria)    
      document.addEventListener("scroll", ()=> {          
          if (document.documentElement.scrollTop > 435) {
            this.rolagemCimaA = false
    }  else{
       this.rolagemCimaA = true
    }
      });
            
    },
    

}
</script>

<style>

.dataincio{
    display: flex;
    align-items: center;
    justify-content: center
}
.dataincio .a{
  text-align: left;
      margin-left: 8px;
}
.dataincio .a span{
  color: #AF3437;
    font-weight: bold;
}
.dataincio .a p{
  color: #565656;
    font-weight: 600;
    
    margin-bottom: 0px;
}
.bloco{
  display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 750px;
    width: 100%;
}
.incial{
  display: flex;
    max-width: 375px;
    justify-content: space-evenly;
    width: 100%;
}
button:focus{
  outline: none;
}
@media print {
  body * {
    visibility: hidden;
  }
  button.btnCa{
    visibility: hidden;
  }
  #printable, #printable * {
    visibility: visible;  
    page-break-before: always;
  }
   #printable tr{
     page-break-before: always;
   }
  #printable {
    height:100%;
    width:100%;
    position: fixed;
   page-break-after: always;
    top: 0;
  }
  
}
.rolagemCima{
    position: fixed;
    height: 55px;
    width: 55px;
    bottom: 78px;
    right: 25px;
    background: #AF3437;
    z-index: 99;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 45px;
    color: #fff;
    transition: 0.5s all;
      box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;
}
.rolagemCimaA{
bottom: -128px;
}
.rolagemCima a{
  text-align: none;
  color:#fff;
   
}
.rolagemCima a:hover{
list-style: none;
outline:none;
border: 0px;
outline-style: none;
}
table {
  width: 900px;
  margin-bottom: 60px;
  border-collapse: collapse;
}
tr:nth-child(even) {
	background-color:#FFE6E6  !important;
	}
  tr:nth-child(odd) {
	background-color:#ffffff  !important;
	}
.thtable {
  background: #AF3437;
  color: white;
  margin: 0;
  font-size: 14px;
  text-align: center !important;
  width: 100px;
  height: 50px;
}

.thtable:first-child {
  border-radius: 10px 0 0 0
}

.thtable:last-child {
  border-radius: 0  10px  0 0 
}
.tdtable {
  width: 100px;
  height: 50px;

  font-size: 15px;
  text-align: center;
}

.tdtable:last-child {
  border:none;
}

.trtable {
  border-left: 1px solid rgb(0,0,0,0.35);
  border-right: 1px solid rgb(0,0,0,0.25);
   border-bottom: 1px solid rgb(0,0,0,0.25);
}

.trtable:first-child {
  border:none;
}

.trtable:last-child {
  border-bottom: 1px solid rgb(0,0,0,0.15);
}

.trtable:nth-child(2) {
  border-top: 1px solid rgb(0,0,0,0.15);
}
.btnCa{
  width: 145px;
   
    height: 48px;
    font-weight: 600;
    font-size: 24px;
    font-style: italic;
    border: none;
    color: #fff;
    background: #AF3437;
    border-radius: 5px;
    margin: 25px 0px;
}
.btnCa:focus{
  outline: none;
}
*{
    outline: none;
}
.calculo-row-border {
  border-bottom: 1px solid rgb(0, 0, 0, 0.25);
  width: 540px;
  justify-self: center;
  margin-bottom: 10px;
}

.calculo-content {
  padding: 50px 20px 75px 40px;
}

.calculo-content p {
  color: #383838;
  margin: 0;
  font-weight: 500;
}

input {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 10px;
  border: none;
  margin: 0 10px 10px 0;
  width:250px;
  height: 45px;
}

.input-container {
  display:inline-block;
  min-width: 158px;
  margin: 0px 25px 22px 35px;
}
.input-style {
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: #D1D1D1;
  width: 45px;
  height: 45px;
  border-radius: 5px 0 0 5px;
}

.input-datafim input {
  z-index: 1;
  width: 140px;
}

.input-datainicio input {
  z-index: 1;
  width: 140px;
}

input {
  padding-left: 50px;
}


.txtNe{
    color:#000;
    font-weight: bold;
}
.containerC{
    margin:0 auto;
    max-width: 1160px; 
    background: #fff;
   
}
.topPainelC{
    background-image: url('/sandboxfront/IGPM/f.png');
    background-color: #AF3437;
    background-size: cover;
    background-blend-mode: multiply;
    height: 10vh;
    display: flex;
    justify-content: center;
    align-items: center;   
    background-repeat: no-repeat;
        background-position-y: -450px;
}
.backgrounConteudo{
    background: #DFDFDF;
    height: 100%;
    width: 100%;
    margin-top:50px;
    position: relative;
}
.backgrounConteudo::after{
    content: '';
    position: absolute;
    width: 0;
    z-index: 8;
    height: 0;
    top: -13px;
    left: 50%;
    -webkit-transform: translate(-50%, -10%);
    transform: translate(-50%, -10%);
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 25px solid #DFDFDF;
}
.containerConteudo{
    margin:0 auto;
    max-width: 900px;     
    width: 100%;
}
</style>